// // import React, { useState, useMemo } from "react";

// // import { formatNumber, mapTableRows } from "../../../../../utils";
// // import { Avatar, Button, NewTableAdv } from "../../../../../components";
// // import AccrodianComponent from "./AccrodianComponent";

// // const NewTableAdvList = () => {
// //   const columns = [
// //     {
// //       key: "fullName",
// //       label: "Employee Name2",

// //       render: (row) => {
// //         const { name } = row;

// //         return (
// //           <div className="flex-1 flex items-center gap-2">
// //             <div>
// //               <Avatar
// //                 alt={name.firstName}
// //                 size="sm"
// //                 src={row.profilePhotoUrl}
// //               />
// //             </div>
// //             <div className="w-fit truncate overflow-hidden whitespace-nowrap">
// //               {name.firstName} {name.middleName} {name.lastName}
// //             </div>
// //           </div>
// //         );
// //       },
// //       // NEW: Add getRowClass function to conditionally style entire rows
// //       getRowClass: (row) => {
// //         // Example conditions for row styling
// //         if (row.status === "Inactive") {
// //           return "bg-red-100 !hover:bg-red-200";
// //         } else if (row.status === "Pending") {
// //           return "bg-yellow-50 hover:bg-yellow-100";
// //         } else if (row.age > 50 && row.department === "Engineering") {
// //           return "bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500";
// //         } else if (row.salery > 8000) {
// //           return "bg-green-50 hover:bg-green-100 font-semibold";
// //         }
// //         return ""; // Default case
// //       },
// //     },

// //     {
// //       key: "email",
// //       label: "Email2",
// //       showAccordianBtn: true,
// //     },
// //     {
// //       key: "age",
// //       label: "Age2",
// //     },
// //     {
// //       key: "department",
// //       label: "Department2",
// //     },

// //     {
// //       key: "status",
// //       label: "Status2",
// //     },
// //     {
// //       key: "countries",
// //       label: "Countries2",
// //     },
// //     {
// //       key: "gender",
// //       label: "Gender2",
// //       getCellClass: (row) => {
// //         if (row.gender === "Male" && row.countries === "India") {
// //           return "bg-green-900 text-white ";
// //         } else if (row.gender === "Female") {
// //           return "bg-pink-300 ";
// //         }
// //         return ""; // Default case
// //       },
// //     },
// //     {
// //       key: "phone",
// //       label: "Phone2",
// //       className: "bg-blue-50",
// //     },
// //     {
// //       key: "address",
// //       label: "Address2",
// //       width: "250px",
// //     },
// //     {
// //       key: "",
// //       label: "Action",
// //     },

// //     {
// //       key: "salery",
// //       label: "Salery2",
// //       className: "bg-blue-50",

// //       total: true,
// //       totalRender: (totalValue, totals) => {
// //         //console.log("totals", totals);
// //         // Example: Add a currency symbol and custom formatting
// //         return <div>Total : $ {formatNumber(totalValue)}</div>;
// //       },
// //     },

// //     {
// //       key: "salery3",
// //       label: "Salery3",
// //       className: "bg-blue-50",

// //       render: (row) => {
// //         return <div className="">$ {formatNumber(row.salery)}</div>;
// //       },
// //       total: true,
// //       valueGetter: (row) => row.salery, // Added to provide raw numeric value
// //       totalRender: (totalValue, totals) => {
// //         //console.log("totals", totals);
// //         return <div>Total : $ {formatNumber(totalValue)}</div>;
// //       },
// //     },
// //   ];

// //   const rows = Array.from({ length: 400 }, (_, i) => ({
// //     id: i + 100,
// //     name: {
// //       firstName: `User ${i + 1}`,
// //       middleName: `Middle Name ${i + 1}`, // Add middleName to the row data for demonstration purposes
// //       lastName: `Last Name ${i + 1}`,
// //     },
// //     profilePhotoUrl: "",
// //     username: `user${i + 1}`,
// //     password: `password${i + 1}`,
// //     email: `user${i + 1}@example.com`,
// //     salery: Math.floor(Math.random() * 10000) + 1000,
// //     birthDate: new Date(
// //       Date.now() - Math.floor(Math.random() * 10000000000)
// //     ).toISOString(),
// //     age: Math.floor(Math.random() * 50) + 18,
// //     company: `Company ${i + 1}`,
// //     department: [
// //       "Engineering",
// //       "Marketing and sales ang hunam",
// //       "Sales",
// //       "HR",
// //       "Finance",
// //     ][Math.floor(Math.random() * 5)],
// //     status: ["Active", "Inactive", "Pending"][Math.floor(Math.random() * 3)],
// //     info: ["", `Some Info for this id ${i + 1}`][Math.floor(Math.random() * 2)],
// //     countries: [
// //       "USA",
// //       "Canada",
// //       "Australia",
// //       "India",
// //       "United Kingdom",
// //       "Germany",
// //       "France",
// //       "Spain",
// //       "Italy",
// //       "Brazil",
// //     ][Math.floor(Math.random() * 10)],
// //     gender: ["Male", "Female"][Math.floor(Math.random() * 2)],

// //     phone: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
// //       Math.random() * 1000
// //     )}-${Math.floor(Math.random() * 10000)}`,
// //     address: `123 Main St, City ${i + 1}, State ${i + 1}, Country ${i + 1}`,
// //   }));

// //   const mappedRows = mapTableRows(rows, columns);

// //   ////////////////////
// //   const [selectedRows, setSelectedRows] = useState([]);

// //   const handleSelectionChange = (selectedRows) => {
// //     setSelectedRows(selectedRows);
// //   };

// //   // Memoize defaultSelectedRows to prevent infinite re-renders
// //   const defaultSelectedRows = useMemo(() => [100, 102, 105], []);

// //   console.log("selectedRows", selectedRows);

// //   return (
// //     <div className="flex-1 flex flex-col overflow-hidden">
// //       {/* <div>{selectedRows.length}</div> */}
// //       <NewTableAdv
// //         columns={columns}
// //         rows={mappedRows}
// //         //fixedCol={3}
// //         //info={"info"}
// //         showSlNo
// //         showCheckbox
// //         accrodian={<AccrodianComponent data={mappedRows} />}
// //         onSelectionChange={handleSelectionChange}
// //         tableId="table1"
// //         //defaultSelectedRows={defaultSelectedRows}
// //         //tdClassName=""
// //         //rowClickeble
// //         toolbarRight={{
// //           search: true,
// //           filter: true,
// //           download: true,
// //           add: [
// //             {
// //               icon: "key",
// //               onClick: () => {
// //                 console.log("Add New");
// //               },
// //             },
// //             {
// //               icon: "close",
// //               onClick: () => {
// //                 console.log("Add New");
// //               },
// //             },
// //             {
// //               component: (
// //                 <Button
// //                   title="Add New"
// //                   size="xs"
// //                   onClick={() => {
// //                     alert("added");
// //                   }}
// //                 />
// //               ),
// //             },
// //           ],
// //         }}
// //         //disableSelection
// //         //singleSelection
// //       />
// //       {/* <AuditHistory /> */}
// //     </div>
// //   );
// // };

// // export default NewTableAdvList;

// import React, { useState, useMemo } from "react";

// import { formatNumber, mapTableRows } from "../../../../../utils";
// import { Avatar, Button, NewTableAdv } from "../../../../../components";
// import AccrodianComponent from "./AccrodianComponent";

// const NewTableAdvList = () => {
//   const columns = [
//     {
//       key: "fullName",
//       label: "Employee Name2",

//       render: (row) => {
//         const { name } = row;

//         return (
//           <div className="flex-1 flex items-center gap-2">
//             <div>
//               <Avatar
//                 alt={name.firstName}
//                 size="sm"
//                 src={row.profilePhotoUrl}
//               />
//             </div>
//             <div className="w-fit truncate overflow-hidden whitespace-nowrap">
//               {name.firstName} {name.middleName} {name.lastName}
//             </div>
//           </div>
//         );
//       },
//       // NEW: Add getRowClass function to conditionally style entire rows
//       // getRowClass: (row) => {
//       //   // Example conditions for row styling
//       //   if (row.status === "Inactive") {
//       //     return "bg-red-100 !hover:bg-red-200";
//       //   } else if (row.status === "Pending") {
//       //     return "bg-yellow-50 hover:bg-yellow-100";
//       //   } else if (row.age > 50 && row.department === "Engineering") {
//       //     return "bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500";
//       //   } else if (row.salery > 8000) {
//       //     return "bg-green-50 hover:bg-green-100 font-semibold";
//       //   }
//       //   return ""; // Default case
//       // },
//     },

//     {
//       key: "email",
//       label: "Email2",
//       showAccordianBtn: true,
//     },
//     {
//       key: "age",
//       label: "Age2",
//     },
//     {
//       key: "department",
//       label: "Department2",
//     },

//     {
//       key: "status",
//       label: "Status2",
//     },
//     {
//       key: "countries",
//       label: "Countries2",
//     },
//     {
//       key: "gender",
//       label: "Gender2",
//       // getCellClass: (row) => {
//       //   if (row.gender === "Male" && row.countries === "India") {
//       //     return "bg-green-900 text-white ";
//       //   } else if (row.gender === "Female") {
//       //     return "bg-pink-300 ";
//       //   }
//       //   return ""; // Default case
//       // },
//     },
//     {
//       key: "phone",
//       label: "Phone2",
//       //className: "bg-blue-50",
//     },
//     {
//       key: "address",
//       label: "Address2",
//       width: "250px",
//     },
//     {
//       key: "",
//       label: "Action",
//     },

//     {
//       key: "salery",
//       label: "Salery2",
//       className: "bg-blue-50",

//       total: true,
//       totalRender: (totalValue, totals) => {
//         //console.log("totals", totals);
//         // Example: Add a currency symbol and custom formatting
//         return <div>Total : $ {formatNumber(totalValue)}</div>;
//       },
//     },

//     {
//       key: "salery3",
//       label: "Salery3",
//       className: "bg-blue-50",

//       render: (row) => {
//         return <div className="">$ {formatNumber(row.salery)}</div>;
//       },
//       total: true,
//       valueGetter: (row) => row.salery, // Added to provide raw numeric value
//       totalRender: (totalValue, totals) => {
//         //console.log("totals", totals);
//         return <div>Total : $ {formatNumber(totalValue)}</div>;
//       },
//     },
//   ];

//   const rows = Array.from({ length: 400 }, (_, i) => ({
//     id: i + 100,
//     name: {
//       firstName: `User ${i + 1}`,
//       middleName: `Middle Name ${i + 1}`, // Add middleName to the row data for demonstration purposes
//       lastName: `Last Name ${i + 1}`,
//     },
//     profilePhotoUrl: "",
//     username: `user${i + 1}`,
//     password: `password${i + 1}`,
//     email: `user${i + 1}@example.com`,
//     salery: Math.floor(Math.random() * 10000) + 1000,
//     birthDate: new Date(
//       Date.now() - Math.floor(Math.random() * 10000000000)
//     ).toISOString(),
//     age: Math.floor(Math.random() * 50) + 18,
//     company: `Company ${i + 1}`,
//     department: [
//       "Engineering",
//       "Marketing and sales ang hunam",
//       "Sales",
//       "HR",
//       "Finance",
//     ][Math.floor(Math.random() * 5)],
//     status: ["Active", "Inactive", "Pending"][Math.floor(Math.random() * 3)],
//     info: ["", `Some Info for this id ${i + 1}`][Math.floor(Math.random() * 2)],
//     countries: [
//       "USA",
//       "Canada",
//       "Australia",
//       "India",
//       "United Kingdom",
//       "Germany",
//       "France",
//       "Spain",
//       "Italy",
//       "Brazil",
//     ][Math.floor(Math.random() * 10)],
//     gender: ["Male", "Female"][Math.floor(Math.random() * 2)],

//     phone: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
//       Math.random() * 1000
//     )}-${Math.floor(Math.random() * 10000)}`,
//     address: `123 Main St, City ${i + 1}, State ${i + 1}, Country ${i + 1}`,
//   }));

//   const mappedRows = mapTableRows(rows, columns);

//   ////////////////////
//   const [selectedRows, setSelectedRows] = useState([]);

//   const handleSelectionChange = (selectedRows) => {
//     setSelectedRows(selectedRows);
//   };

//   // Memoize defaultSelectedRows to prevent infinite re-renders
//   const defaultSelectedRows = useMemo(() => [100, 102, 105], []);

//   console.log("selectedRows", selectedRows);
//   ////////////////////////////////////////
//   ////////////////////////////////////////
//   const [searchValue, setSearchValue] = useState("");

//   const handleSearch = (keyname, value) => {
//     setSearchValue(value);
//   };

//   return (
//     <div className="flex-1 flex overflow-hidden gap-10">
//       {/* <div>{selectedRows.length}</div> */}
//       <div className="flex-1  flex flex-col overflow-hidden">
//         {searchValue}
//         <NewTableAdv
//           columns={columns}
//           rows={mappedRows}
//           fixedCol={1}
//           //info={"info"}
//           showSlNo
//           showCheckbox
//           accrodian={<AccrodianComponent data={mappedRows} />}
//           onSelectionChange={handleSelectionChange}
//           tableId="componentsList-testTable"
//           //defaultSelectedRows={defaultSelectedRows}
//           //tdClassName=""
//           //rowClickeble
//           toolbarRight={{
//             search: true,
//             filter: true,
//             download: true,
//             add: [
//               {
//                 icon: "key",
//                 onClick: () => {
//                   console.log("Add New");
//                 },
//               },
//               {
//                 icon: "close",
//                 onClick: () => {
//                   console.log("Add New");
//                 },
//               },
//               {
//                 component: (
//                   <Button
//                     title="Add New"
//                     size="xs"
//                     onClick={() => {
//                       alert("added");
//                     }}
//                   />
//                 ),
//               },
//             ],
//           }}
//           //disableSelection
//           //singleSelection
//           serverSerchValue={searchValue}
//           serverOnSearch={handleSearch}
//         />
//       </div>
//       {/* <div className="flex-1  flex flex-col overflow-hidden">
//         <NewTableAdv
//           columns={columns}
//           rows={mappedRows}
//           //fixedCol={3}
//           //info={"info"}
//           showSlNo
//           showCheckbox
//           accrodian={<AccrodianComponent data={mappedRows} />}
//           onSelectionChange={handleSelectionChange}
//           tableId="componentsList-testTable-2"
//           //defaultSelectedRows={defaultSelectedRows}
//           //tdClassName=""
//           //rowClickeble
//           toolbarRight={{
//             search: true,
//             filter: true,
//             download: true,
//             add: [
//               {
//                 icon: "key",
//                 onClick: () => {
//                   console.log("Add New");
//                 },
//               },
//               {
//                 icon: "close",
//                 onClick: () => {
//                   console.log("Add New");
//                 },
//               },
//               {
//                 component: (
//                   <Button
//                     title="Add New"
//                     size="xs"
//                     onClick={() => {
//                       alert("added");
//                     }}
//                   />
//                 ),
//               },
//             ],
//           }}
//           //disableSelection
//           //singleSelection
//         />
//       </div> */}
//     </div>
//   );
// };

// export default NewTableAdvList;

import React, { useState, useMemo } from "react";

import { formatNumber, mapTableRows } from "../../../../../utils";
import { Avatar, Button, Chip, NewTableAdv } from "../../../../../components";
import AccrodianComponent from "./AccrodianComponent";

const NewTableAdvList = () => {
  const columns = [
    // {
    //   key: "edita",
    //   label: "",
    //   render: (row) => {
    //     return (
    //       <div className="flex items-center justify-center">
    //         {row.edita === "true" ? (
    //           <span class="material-symbols-outlined !text-[18px]">
    //             check_box
    //           </span>
    //         ) : (
    //           <span class="material-symbols-outlined !text-[18px]">
    //             check_box_outline_blank
    //           </span>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      key: "fullName",
      label: "Employee Name2",

      render: (row) => {
        const { name } = row;

        return (
          <div className="flex-1 flex items-center gap-2">
            {name.firstName} {name.middleName} {name.lastName}
          </div>
        );
      },

      // NEW: Add getRowClass function to conditionally style entire rows
      // getRowClass: (row) => {
      //   // Example conditions for row styling
      //   if (row.status === "Inactive") {
      //     return "bg-red-100 !hover:bg-red-200";
      //   } else if (row.status === "Pending") {
      //     return "bg-yellow-50 hover:bg-yellow-100";
      //   } else if (row.age > 50 && row.department === "Engineering") {
      //     return "bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500";
      //   } else if (row.salery > 8000) {
      //     return "bg-green-50 hover:bg-green-100 font-semibold";
      //   }
      //   return ""; // Default case
      // },
    },

    {
      key: "email",
      label: "Email2",
      showAccordianBtn: true,
    },
    {
      key: "age",
      label: "Age2",
    },
    {
      key: "department",
      label: "Department2",
    },

    {
      key: "status",
      label: "Status2",
    },
    {
      key: "countries",
      label: "Countries2",
    },
    {
      key: "gender",
      label: "Gender2",
      // getCellClass: (row) => {
      //   if (row.gender === "Male" && row.countries === "India") {
      //     return "bg-green-900 text-white ";
      //   } else if (row.gender === "Female") {
      //     return "bg-pink-300 ";
      //   }
      //   return ""; // Default case
      // },
    },
    {
      key: "phone",
      label: "Phone2",
      //className: "bg-blue-50",
    },
    {
      key: "address",
      label: "Address2",
      getRowClass: (row) => {
        if (row.edita === "true") {
          return "cursor-not-allowed opacity-50";
        }
        return "";
      },
    },
    // {
    //   key: "",
    //   label: "Action",
    // },

    // {
    //   key: "salery",
    //   label: "Salery2",
    //   className: "bg-blue-50",

    //   total: true,
    //   totalRender: (totalValue, totals) => {
    //     //console.log("totals", totals);
    //     // Example: Add a currency symbol and custom formatting
    //     return <div>Total : $ {formatNumber(totalValue)}</div>;
    //   },
    // },

    // {
    //   key: "salery3",
    //   label: "Salery3",
    //   className: "bg-blue-50",

    //   render: (row) => {
    //     return <div className="">$ {formatNumber(row.salery)}</div>;
    //   },
    //   total: true,
    //   valueGetter: (row) => row.salery, // Added to provide raw numeric value
    //   totalRender: (totalValue, totals) => {
    //     //console.log("totals", totals);
    //     return <div>Total : $ {formatNumber(totalValue)}</div>;
    //   },
    // },
  ];

  const rows = Array.from({ length: 4 }, (_, i) => ({
    id: i + 100,
    name: {
      firstName: `User ${i + 1}`,
      middleName: `Middle Name ${i + 1}`, // Add middleName to the row data for demonstration purposes
      lastName: `Last Name ${i + 1}`,
    },
    profilePhotoUrl: "",
    username: `user${i + 1}`,
    password: `password${i + 1}`,
    email: `user${i + 1}@example.com`,
    salery: Math.floor(Math.random() * 10000) + 1000,
    birthDate: new Date(
      Date.now() - Math.floor(Math.random() * 10000000000)
    ).toISOString(),
    age: Math.floor(Math.random() * 50) + 18,
    company: `Company ${i + 1}`,
    department: [
      "Engineering",
      "Marketing and sales ang hunam",
      "Sales",
      "HR",
      "Finance",
    ][Math.floor(Math.random() * 5)],
    status: ["Active", "Inactive", "Pending"][Math.floor(Math.random() * 3)],
    info: ["", `Some Info for this id ${i + 1}`][Math.floor(Math.random() * 2)],
    countries: [
      "USA",
      "Canada",
      "Australia",
      "India",
      "United Kingdom",
      "Germany",
      "France",
      "Spain",
      "Italy",
      "Brazil",
    ][Math.floor(Math.random() * 10)],
    gender: ["Male", "Female"][Math.floor(Math.random() * 2)],
    edita: i === 1 || i === 2 ? "true" : "false", // Only first 2 rows will be true, rest will be false
    phone: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
      Math.random() * 1000
    )}-${Math.floor(Math.random() * 10000)}`,
    address: `123 Main St, City ${i + 1}, State ${i + 1}, Country ${i + 1}`,
  }));

  const mappedRows = mapTableRows(rows, columns);

  return (
    <div>
      <NewTableAdv columns={columns} rows={mappedRows} />
    </div>
  );
};

export default NewTableAdvList;
